/**
 * Created by pajicv on 10/26/18.
 */
import React from 'react';
import { Button, Typography, withStyles } from '@material-ui/core';
import Task from '../Tasks/Task.enhancer';
import TaskCollapsed from '../Tasks/TaskCollapsed.enhancer';
import classnames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';
import {MAIN_COLOR} from '../../firebase-config';

const styles = theme => ({
    fab: {
        position: 'absolute',
        top: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    fabText: {
        color: MAIN_COLOR,
        fontSize: 22
    }
});

class TaskOverlay extends React.Component {

    render() {
        const { classes, taskOverlayCollapsed, onCloseTask } = this.props;
        return (
            <div onClick={(e)=>console.log(e)} style={{ position: 'relative', width: '100%', height: '100%', overflow: 'auto'}}>
                {
                    !taskOverlayCollapsed ? (
                        <React.Fragment>
                            <Button className={classes.fab} onClick={onCloseTask}>
                                <CloseIcon />
                            </Button>
                            <Task {...this.props} />
                        </React.Fragment>
                    ) : (
                        <TaskCollapsed {...this.props} />
                    )
                }
            </div>
        );
    }
}

export default withStyles(styles)(TaskOverlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/TaskOverlay.js